import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByAsc, orderByDateDsc } from './format'

export function newSupplier(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_SUPPLIER_START", payload: "" })
            console.log("new Supplier START", {data})
            const res = await axios.post('/suppliers/new',{data})
            console.log({res});

            if (checkErrorData(res, "CREATE_SUPPLIER_ERROR", dispatch) ){                
				dispatch({ type: "NEW_SUPPLIER", payload: res.data })
				dispatch({ type: "CREATE_SUPPLIER_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new supplier ", err);
            dispatch({
                type: "CREATE_SUPPLIER_ERROR",
                payload: err
            })
        }
    }
}

export function fetchSuppliers() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_SUPPLIERS_START", payload: "" })
            
            console.log("fetch Supplier START")
            const res = await axios.get('/suppliers/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_SUPPLIERS_ERROR", dispatch) ){ 
                dispatch({
                    type: "GET_SUPPLIERS",
                    payload: formatList(orderByAsc(res.data, "supplier_name"), "supplier_id")
                })
                dispatch({ type: "FETCH_SUPPLIERS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get suppliers list ", err);
            dispatch({ type: "FETCH_SUPPLIERS_ERROR", payload: err })
        }
    }
}


// Propose le prochain compte fournisseur : {supplier_category, supplier_advance_category}.
// Renvoie null si indisponible (ancien backend, reseau) : le formulaire reste utilisable.
export async function fetchNextSupplierAccount() {
    try {
        const res = await axios.get('/suppliers/next-account')
        if (res.data && !res.data.error && res.data.supplier_category) {
            return res.data
        }
        console.warn("[WARN] next supplier account indisponible", res.data && res.data.error)
    } catch(err) {
        console.warn("[WARN] next supplier account indisponible", err)
    }
    return null
}


export function updateSupplier(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_SUPPLIER_START", payload: "" })

            console.log("update Supplier START")
            const res = await axios.post("/suppliers/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_SUPPLIER_ERROR", dispatch) ){  
               
				dispatch({
                    type: "UPDATE_SUPPLIER",
                    payload: data
                })
				dispatch({ type: "UPDATE_SUPPLIER_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update supplier ", err);
            dispatch({
                type: "UPDATE_SUPPLIER_ERROR",
                payload: err
                
            })
        }
    }
}

export function newSupplierAdvance(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_SUPPLIER_ADVANCE_START", payload: "" })
            console.log("new Advance START", {data})
            const res = await axios.post('/suppliers/advance/new',{data})
            console.log({res});

            if(checkErrorData(res, "CREATE_SUPPLIER_ADVANCE_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_SUPPLIER_ADVANCE", payload: res.data })
                dispatch({ type: "DEBIT_SUPPLIER_ACCOUNT", payload: {supplier_id: data.advance_supplier_id, amount: (data.advance_amount * -1)} })
				dispatch({ type: "CREATE_SUPPLIER_ADVANCE_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new advance ", err);
            dispatch({
                type: "CREATE_SUPPLIER_ADVANCE_ERROR",
                payload: err
            })
        }
    }
}
export function newAdvanceReturn(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_ADVANCE_RETURN_START", payload: "" })
            console.log("new Advance START", {data})
            const res = await axios.post('/suppliers/advance/return/new',{data})
            console.log({res});

            if(checkErrorData(res, "CREATE_ADVANCE_RETURN_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_ADVANCE_RETURN", payload: res.data })
                // update advance rest UPDATE_ADVANCE_REST
                dispatch({ type: "UPDATE_ADVANCE_REST", payload: res.data })
                // update supplier account -- DEBIT_SUPPLIER_ACCOUNT
                dispatch({ type: "DEBIT_SUPPLIER_ACCOUNT", payload: {supplier_id: data.advance_supplier_id, amount: data.advance_amount} })
				dispatch({ type: "CREATE_ADVANCE_RETURN_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new advance ", err);
            dispatch({
                type: "CREATE_ADVANCE_RETURN_ERROR",
                payload: err
            })
        }
    }
}

export function fetchSupplierAdvances() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_ADVANCES_START", payload: "" })
            
            console.log("fetch Advance START")
            const res = await axios.get('/suppliers/advance/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_ADVANCES_ERROR", dispatch) ){ 
                dispatch({
                    type: "GET_ADVANCES",
                    payload: formatList(orderByDateDsc(res.data, "advance_date"), "advance_id")
                })
                dispatch({ type: "FETCH_ADVANCES_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get suppliers list ", err);
            dispatch({ type: "FETCH_ADVANCES_ERROR", payload: err })
        }
    }
}
export function deleteSupplierAdvance(advance_id) {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "DELETE_SUPPLIER_ADVANCE_START", payload: "" })

            console.log("delete SupplierAdvance START")
            const res = await axios.post("/suppliers/advance/delete", {data: advance_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_SUPPLIER_ADVANCE_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_SUPPLIER_ADVANCE",
                    payload: advance_id
                })
                dispatch({ type: "DELETE_SUPPLIER_ADVANCE_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete advance ", err);
            dispatch({
                type: "DELETE_SUPPLIER_ADVANCE_ERROR",
                payload: err
            })
        }
    }
}

export function fetchAdvanceReturns() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_ADVANCE_RETURNS_START", payload: "" })
            console.log("fetch advance return START")
            const res = await axios.get('/suppliers/advance/return/get/all')
            console.log({res});
            
            if(checkErrorData(res, "FETCH_ADVANCE_RETURNS_ERROR", dispatch ) ) {
                dispatch({
                    type: "GET_ADVANCE_RETURNS",
                    payload: formatList(orderByDateDsc(res.data, "advance_creation_date"), "advance_id")
                })
				dispatch({ type: "FETCH_ADVANCE_RETURNS_FULFILLED", payload: "" })
                
			}            
        } catch(err) {
            console.log("[ERROR] get suppliers list ", err);
        }
    }
}

export function deleteAdvanceReturn(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "DELETE_ADVANCE_RETURN_START", payload: "" })

            console.log("delete advance/return START", data)
            const res = await axios.post("/suppliers/advance/return/delete", {data: data.advance_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_ADVANCE_RETURN_ERROR", dispatch ) ) {
                data.advance_amount = data.advance_amount * -1
                dispatch({ type: "UPDATE_ADVANCE_REST", payload: data })
                dispatch({ type: "DEBIT_SUPPLIER_ACCOUNT", payload: {supplier_id: data.advance_supplier_id, amount: data.advance_amount } })
                dispatch({
                    type: "DELETE_ADVANCE_RETURN",
                    payload: data.advance_id,
                })

                dispatch({ type: "DELETE_ADVANCE_RETURN_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete debit ", err);
            dispatch({
                type: "DELETE_ADVANCE_RETURN_ERROR",
                payload: err
            })
        }
    }
}

export function deleteSupplier(supplier_id) {
    return async function(dispatch, getState){
        try{
            dispatch({ type: "DELETE_SUPPLIER_START", payload: "" })

            console.log("delete Supplier START")
            const res = await axios.post("/suppliers/delete", {data: supplier_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_SUPPLIER_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_SUPPLIER",
                    payload: supplier_id
                })
                dispatch({ type: "DELETE_SUPPLIER_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete supplier ", err);
            dispatch({
                type: "DELETE_SUPPLIER_ERROR",
                payload: err
            })
        }
    }
}